import { Badge } from "@/components/ui/badge"
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card"
import { DateTimeField, issuesFor, type SeasonFieldsProps } from "./SeasonFields"

/**
 * Which appointment times the public can be booked into, as opposed to when they may book: booking
 * can open on Oct 1 with appointments offered only from Oct 15. Both sides optional.
 */
export function AppointmentWindowCard({ form, issues, onChange }: SeasonFieldsProps) {
  const limited = Boolean(form.firstAppointmentAt || form.appointmentsEndAt)

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex flex-wrap items-center gap-2">
          Appointments window
          <Badge variant={limited ? "secondary" : "outline"}>{limited ? "Limited" : "No limit"}</Badge>
        </CardTitle>
        <CardDescription>
          The appointment times the public website and phone line can book into. Leave either blank for no limit on
          that side. Staff booking is never limited.
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="grid gap-4 sm:grid-cols-2">
          <DateTimeField
            id="season-first-appointment"
            label="First appointment time (Pacific time)"
            hint="No public appointment is offered before this moment."
            optional
            value={form.firstAppointmentAt}
            issues={issuesFor(issues, "firstAppointmentAt")}
            onChange={(firstAppointmentAt) => onChange({ firstAppointmentAt })}
          />
          <DateTimeField
            id="season-appointments-end"
            label="No appointments after time (Pacific time)"
            hint="No public appointment is offered at or after this moment."
            optional
            value={form.appointmentsEndAt}
            issues={issuesFor(issues, "appointmentsEndAt")}
            onChange={(appointmentsEndAt) => onChange({ appointmentsEndAt })}
          />
        </div>
      </CardContent>
    </Card>
  )
}
